import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Drawer, DrawerContent, DrawerTitle } from '@/components/ui/drawer';
import useIsMobile from '@/hooks/use-is-mobile';

interface Props {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}
const WaistTipDialog = (props: Props) => {
  const { open, onConfirm, onCancel } = props;
  const isMobile = useIsMobile();

  const content = (
    <>
      <div className='flex justify-end'>
        <button
          type='button'
          className='flex h-[46px] w-[46px] items-center justify-center lg_h-[60px] lg_w-[60px]'
          onClick={onCancel}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            fill='none'
            viewBox='0 0 18 18'
            className='h-auto w-4'
          >
            <path
              stroke='#80583F'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='1.5'
              d='M17 17 1 1m16 0L1 17'
            ></path>
          </svg>
        </button>
      </div>
      <div className='mt-[83px]  px-[37px] pb-[119px] lg_mt-[46px] lg_px-[50px] lg_pb-[96px]'>
        <p className='text-[17px] leading-[1.7]'>
          The waist measurement you entered is larger than both bust and hip. Would you like to proceed?
        </p>
        <button
          type='button'
          onClick={onConfirm}
          className='group mt-[60px] flex h-[50px] w-full items-center justify-center gap-x-2.5 rounded-[3px] border-1  border-solid border-80583F bg-80583F text-white lg_hover_bg-white lg_hover_text-80583F'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='12'
            fill='none'
            viewBox='0 0 14 12'
            className='hidden lg_block'
          >
            <path
              className='stroke-white lg_group-hover_stroke-80583F'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='1.5'
              d='m13 1.5-8.4 9L1 6.9'
            ></path>
          </svg>
          <span className='text-[15px] font-medium'>YES, MY MEASUREMENTS ARE CORRECT</span>
        </button>
        <button
          type='button'
          onClick={onCancel}
          className='mt-5 flex h-[50px] w-full items-center justify-center gap-x-2.5 rounded-[3px] border-1  border-solid border-80583F  text-80583F '
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='19'
            height='20'
            fill='none'
            viewBox='0 0 19 20'
          >
            <path
              fill='#80583F'
              d='M2.629 17.43h13.827v1.209H2.63zm.982-2.419h.163l3.6-1.209c.082 0 .164-.086.246-.173l8.182-8.636a.68.68 0 0 0 .163-.432.68.68 0 0 0-.163-.432l-2.537-2.677c-.245-.259-.572-.259-.818 0L4.265 10.09c-.082.086-.082.172-.163.259l-1.146 3.8c-.082.259 0 .431.164.604q.245.26.49.26m1.636-4.145 7.61-8.032 1.717 1.814-7.609 8.031-2.454.778z'
            ></path>
          </svg>
          <span className='text-[15px] font-medium'>I NEED TO ADJUST THEMS</span>
        </button>
      </div>
    </>
  );

  return isMobile ? (
    <Drawer
      direction='bottom'
      open={open}
      onOpenChange={onCancel}
    >
      <DrawerContent
        className='fixed bottom-0 left-0 z-[2010] w-full rounded-tl-[3px] rounded-tr-[3px] bg-white'
        maskClassName='z-[2000]'
      >
        <DrawerTitle className='hidden'>waist tip drawer</DrawerTitle>
        {content}
      </DrawerContent>
    </Drawer>
  ) : (
    <Dialog
      open={open}
      onOpenChange={onCancel}
    >
      <DialogContent
        showCloseButton={false}
        className='z-[2010] gap-0 p-0'
        maskClassName='z-[2000]'
      >
        <DialogTitle className='hidden'>waist tip dialog</DialogTitle>
        {content}
      </DialogContent>
    </Dialog>
  );
};

export default WaistTipDialog;
